import React, { useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import constant from '../../../constant';

const BuilderForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        builderName: {
            name: 'builderName',
            value: data?.BUILDER_NAME || '',
            isRequired: true,
            error: '',
        },
        contactPersonName: {
            name: 'contactPersonName',
            value: data?.CONTACT_PERSON_NAME || '',
            isRequired: false,
            error: '',
        },
        email: {
            name: 'email',
            value: data?.EMAIL || '',
            isRequired: true,
            error: '',
        },
        phone: {
            name: 'phone',
            value: data?.PHONE || '',
            isRequired: true,
            error: '',
        },
        description: {
            name: 'description',
            value: data?.DESCRIPTION || '',
            isRequired: false,
            error: '',
        },
        isActive: {
            name: 'isActive',
            value: data?.IS_ACTIVE ?? true,
            isRequired: false,
        },
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : '',
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    const handleReset = () => {
        const resetState = { ...state };
        Object.keys(resetState).forEach(key => {
            resetState[key].value = data?.[key.toUpperCase()] || (key === 'isActive' ? true : '');
            resetState[key].error = '';
        });
        setState(resetState);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {[
                    { label: 'Builder Name', name: 'builderName', placeholder: 'Enter builder name' },
                    { label: 'Contact Person Name', name: 'contactPersonName', placeholder: 'Enter contact person name' },
                    { label: 'Email', name: 'email', placeholder: 'Enter email address' },
                    { label: 'Phone', name: 'phone', placeholder: 'Enter phone number' },
                ].map(({ label, name, placeholder }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
                        <input
                            type="text"
                            name={state[name].name}
                            value={state[name].value}
                            onChange={handleChange}
                            placeholder={placeholder}
                            className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                        />
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Description</label>
                    <textarea
                        name={state.description.name}
                        value={state.description.value}
                        onChange={handleChange}
                        className="form-control"
                        rows="3"
                        placeholder="Enter any description"
                    />
                </div>

                <div className="col-md-4 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.listBuilderMasterData.url}>
                    Cancel
                </a>
            </div>
        </form>
    );
};

export default BuilderForm;
